import { Measure } from './measure';
import { FactTable } from './fact-table';
import { Dimension } from './dimension';

export class SecondaryFacttable {
    factId?: string;
    joinCriterias: JoinCriteria[] = [];
    measureIds: string[] = [];
    measures?: Measure[] = [];
    facttable?: FactTable;
    join: string = '';
    joinType?: JoinType;

    static fromJson(json: any): SecondaryFacttable {
        let secondaryFactTable = new SecondaryFacttable();
        secondaryFactTable.factId = json.factId;
        secondaryFactTable.joinCriterias = json.joinCriterias;
        secondaryFactTable.measureIds = json.measureIds;
        secondaryFactTable.facttable = json.facttable;
        secondaryFactTable.join = json.join;
        secondaryFactTable.joinType = json.joinType;
        return secondaryFactTable;
    }
}

export class JoinCriteria {
    leadingRolePlayingDimensionId?: string;
    secondaryRolePlayingDimensionId?: string;
    leadingDimension?: Dimension;
    secondaryDimension?: Dimension;
}

export class JoinType {

    static readonly inner = new JoinType('Schnittmenge', 'inner', '∩');
    static readonly union = new JoinType('Vereinigung', 'union', '∪');
    static readonly left = new JoinType('Inklusion', 'left', '⊆');

    private constructor(
        public readonly caption: string,
        public readonly type: string,
        public readonly mathSymbol: string,
    ){
    }

    static getJoinType(joinType: string): JoinType{
        if(joinType === 'inner'){
            return JoinType.inner;
        } else if(joinType === 'union'){
            return JoinType.union;
        } else {
            return JoinType.left;
        }
    }
}
